"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _react = _interopRequireWildcard(require("react"));

var _styledSystem = require("styled-system");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactFlattenChildren = _interopRequireDefault(require("react-flatten-children"));

var _ = require("../");

var _Breadcrumb = _interopRequireDefault(require("./Breadcrumb"));

var _excluded = ["children"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Container = ( /*#__PURE__*/0, _styledBase["default"])(_.Flex, {
  target: "e17x6xd80",
  label: "Container"
})("*:last-child{font-weight:", (0, _styledSystem.themeGet)('fontWeights.bold'), ";}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

var Chevron = /*#__PURE__*/_react["default"].createElement(_.Icon, {
  name: "chevronRight",
  color: "greys.alto",
  size: 22,
  mx: 1
});

var prepareCrumbs = function prepareCrumbs(children) {
  var flattened = (0, _reactFlattenChildren["default"])(children);
  var hasMultiple = flattened.filter(Boolean).length > 1;
  var current = hasMultiple ? flattened[flattened.length - 1] : children;

  var labelled = /*#__PURE__*/_react["default"].cloneElement(current, {
    'aria-current': 'page'
  });

  if (hasMultiple) {
    flattened.splice(flattened.length - 1, 1, labelled);
    var separated = flattened.reduce(function (prev, curr) {
      return [prev, Chevron, curr];
    });
    return _react.Children.toArray(separated);
  } else {
    return labelled;
  }
};

var Breadcrumbs = function Breadcrumbs(_ref) {
  var children = _ref.children,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(Container, (0, _extends2["default"])({
    verticalAlign: "center"
  }, props), prepareCrumbs(children));
};

Breadcrumbs.propTypes = _objectSpread({
  children: _propTypes["default"].node.isRequired
}, _.Flex.propTypes);
Breadcrumbs.defaultProps = _objectSpread({}, _.Flex.defaultProps);
Breadcrumbs.Crumb = _Breadcrumb["default"];
var _default = Breadcrumbs;
exports["default"] = _default;